export default new URL("../images/slide3.jpg", import.meta.url).href;